import React, { useState, useEffect } from "react";
import {
  Alert,
  Button,
  ButtonGroup,
  Container,
  Card,
  Col,
  Form,
  Row,
  Modal,
  Spinner,
} from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import moment from "moment";
import * as Yup from "yup";
import { Formik } from "formik";
import { HexColorPicker } from "react-colorful";

import CustomNavbar from "../../../components/CustomNavbar";
import CustomTable from "../../../components/CustomTable";

import {
  getStatuss,
  saveStatus,
  editStatus,
  deleteStatus,
} from "../../../redux/Modulo_Sanciones/status/actions";

import messages from "../../../redux/messages";
// import SidebarBoarding from "../../../components/OnBoarding_OffBoarding/sidebar_On_Off_Boarding";
import SidebarBoarding from "../../../components/SidebarDashboard";

const schema = Yup.object().shape({
  nombre: Yup.string()
    .matches(/[\w]/, "Formato no correcto")
    .required("**Campo requerido"),
  color_a_mostrar: Yup.string().required("**Campo requerido"),
});

const Sansiones_status = (props) => {
  //const [offset, setOffset] = useState(0);
  //const [limit, setLimit] = useState(10);
  //const [currentPage, setCurrentPage] = useState(1);
  const [edit, setEdit] = useState(false);
  const [index, setIndex] = useState(0);
  const [editItem, setEditItem] = useState({});
  const [showModal, setShowModal] = useState(false);
  //const [filter, setFilter] = useState("");
  const [validated, setValidated] = useState(false);
  const [show, setShow] = useState(false);

  /*const [tipoBusqueda, setTipoBusqueda] = useState({
    id: "nombre",
    desc: "Nombre",
  });*/

  const userRoles = useSelector((store) => store.auth.userRoles);

  const dispatch = useDispatch();

  // const filters = [
  //   { id: "nombre", desc: "Nombre" },
  //   { id: "descripcion", desc: "Descripción" },
  // ];

  const {
    loaderStatuss,
    saveLoaderStatus,
    statuss,
    statussFaild,
    statusFormFaild,
  } = useSelector((store) => store.sancionesStatus);

  //const pages = Math.ceil(statuss ? statuss.count() : 0 / limit);

  const columns = [
    {
      Header: "Nombre",
      accessor: "nombre",
    },
    {
      id: "color",
      Header: "Color asignado",
      Filter: "",
      Cell: (value) => (
        <div
          style={{
            backgroundColor: value.row.original.color_a_mostrar,
            padding: "1rem",
            width: "100px",
            height: "20px",
            borderRadius: "1.5rem",
          }}
        ></div>
      ),
    },
    {
      id: "fecha_creacion",
      Header: "Fecha creación",
      accessor: "fecha_creacion",
      Filter: "",
      Cell: (value) => (
        <div>
          {moment(value.row.original.fecha_creacion).format("DD/MM/YYYY")}
        </div>
      ),
    },
    {
      id: "customButtons",
      Filter: "",
      Cell: (value) => (
        <div className="btn-group" role="group">
          <Button
            size="sm"
            variant="link"
            type="button"
            onClick={() => onEdit(value.row.original, value.row.index)}
          >
            <i className="material-icons">edit</i>
          </Button>
          <Button
            size="sm"
            className="text-danger"
            variant="link"
            type="button"
            onClick={() => onDelete(value.row.original.id, value.row.index)}
          >
            <i className="material-icons">close</i>
          </Button>
        </div>
      ),
    },
  ];

  // Métodos
  const _getStatuss = () => dispatch(getStatuss({}));

  useEffect(() => {
    _getStatuss();
  }, []);

  const onAdd = () => {
    setShowModal(true);
    setEdit(false);
    setValidated(false);
  };

  const onEdit = (item, index) => {
    setIndex(index);
    setEdit(true);
    setEditItem(item);
    setShowModal(true);
    setValidated(false);
  };

  const onSearch = (e) => {
    e.preventDefault();
    /* setFilter(e.target.filter.value);
    const oOffset = 0;
    setOffset(oOffset);
    setCurrentPage(1);
    getADisciplinaryAction(oOffset, limit, e.target.filter.value); */
    _getStatuss();
  };
  const onSubmit = (values) => {
    console.log(values);
    /* e.preventDefault();
    const form = e.currentTarget;
    if (form.checkValidity() === false) {
      setValidated(true);
      return;
    }

    const req = {
      nombre: e.target.nombre.value,
      descripcion: e.target.descripcion.value,
      fecha_creacion: moment(new Date()).format("YYYY-MM-DD"),
    };*/

    if (!edit) {
      dispatch(saveStatus(values, setShowModal));
      //e.target.reset();
      //setShowModal(false);
    } else {
      dispatch(editStatus(values, editItem.id, index, setShowModal));
      //setShowModal(false);
    }
  };

  //const seeAll = () => _getStatuss();

  const onDelete = (id, index) => {
    if (window.confirm(messages.preguntaEliminar)) {
      dispatch(deleteStatus(id, index));
    }
  };

  const onShowSidebar = () => setShow(show ? false : true);

  return (
    <>
      <CustomNavbar type={"dashboard"} onShowSidebar={onShowSidebar} />
      <SidebarBoarding show={show} onShowSidebar={onShowSidebar} />
      <div className="custom-wrapper">
        <Container fluid>
          <div className="my-1 pl-md-4 pr-md-3 pl-2 pr-1 d-flex flex-wrap justify-content-between align-items-center">
            <h6 className="font-weight-bold text-uppercase">Estatus</h6>
            <Form onSubmit={onSearch}>
              <Row className="justify-content-end align-items-center flex-nowrap">
                {/* <Col>
                  <h6>
                    <b>Busqueda por: {tipoBusqueda.desc}</b>
                  </h6>
                </Col>
                <Col xs="auto">
                  <Form.Control
                    name="filter"
                    id="filter"
                    placeholder="Buscar"
                    className="rounded-pill form-control-sm"
                    type="search"
                  ></Form.Control>
                </Col> */}
                <Col xs="auto">
                  <ButtonGroup>
                    {/*<Button
                      onClick={() => seeAll()}
                      variant="light"
                      size="sm"
                      className="rounded-circle">
                      <i className="material-icons">visibility</i>
                    </Button> 
                    <ButtonGroup>
                      <OverlayTrigger
                        placement="auto"
                        overlay={
                          <Tooltip {...props}>Seleccionar Filtrado</Tooltip>
                        }
                      >
                        <Dropdown className="ml-3 mr-3">
                          <Dropdown.Toggle
                            variant="primary"
                            className="btn-sm font"
                          >
                            <i className="material-icons">filter_list</i>
                          </Dropdown.Toggle>
                          <Dropdown.Menu>
                            {filters.map((item) => (
                              <Dropdown.Item
                                onClick={() => setTipoBusqueda(item)}
                                key={item.id}
                              >
                                {item.desc}
                              </Dropdown.Item>
                            ))}
                          </Dropdown.Menu>
                        </Dropdown>
                      </OverlayTrigger>
                    </ButtonGroup>*/}
                    <Button
                      variant="light"
                      size="sm"
                      className="rounded-circle"
                      onClick={() => onAdd()}
                    >
                      <i className="material-icons">add</i>
                    </Button>
                  </ButtonGroup>
                </Col>
              </Row>
            </Form>
          </div>
          {statussFaild && (
            <Alert variant="danger" className="mt-4 mb-1 mx-3">
              {statussFaild}
            </Alert>
          )}
          {loaderStatuss ? (
            <div className="d-flex justify-content-center">
              <Spinner
                animation="border"
                role="status"
                className="d-flex justify-content-center"
              />
            </div>
          ) : statuss && statuss.data.length > 0 ? (
            <>
              <Card className="border-0">
                <Card.Body className="px-1 px-sm-2">
                  <CustomTable columns={columns} data={statuss.data} />
                </Card.Body>
              </Card>
            </>
          ) : (
            <Alert variant="info" className="my-4">
              Aún no hay tipos de falta, comienza agregando algunos
            </Alert>
          )}
        </Container>
      </div>
      <Modal show={showModal} onHide={() => setShowModal(false)}>
        <Formik
          validationSchema={schema}
          onSubmit={onSubmit}
          initialValues={{
            nombre: edit ? editItem.nombre : "",
            color_a_mostrar: edit ? editItem.color_a_mostrar : "#29b368",
          }}
        >
          {({
            handleSubmit,
            handleChange,
            setFieldValue,
            values,
            touched,
            isValid,
            errors,
          }) => (
            <Form onSubmit={handleSubmit} noValidate validated={validated}>
              <Modal.Header closeButton>
                <Modal.Title className="text-muted">
                  {edit ? "Editar estatus" : "Crear estatus"}
                </Modal.Title>
              </Modal.Header>
              <Modal.Body>
                {statusFormFaild && (
                  <Alert variant="danger" className="mt-4 mb-1 mx-3">
                    {statusFormFaild}
                  </Alert>
                )}
                <Form.Group className="mb-3">
                  <Form.Label htmlFor="nombre" column sm="12" md="12">
                    Nombre del estatus
                  </Form.Label>
                  <Form.Control
                    id="nombre"
                    name="nombre"
                    className="rounded-pill"
                    required
                    type="text"
                    value={values.nombre}
                    placeholder="Nombre del estatus"
                    onChange={(e) => handleChange(e)}
                    isInvalid={touched.nombre && !!errors.nombre}
                  ></Form.Control>
                  <Form.Control.Feedback type="invalid">
                    {errors.nombre}
                  </Form.Control.Feedback>
                </Form.Group>
                <Form.Group className="mb-3">
                  <Form.Label className="mb-3 ml-3" htmlFor="color_a_mostrar">
                    Color del estatus
                  </Form.Label>
                  <HexColorPicker
                    id="color_a_mostrar"
                    onInvalid={touched.color && !!errors.color}
                    color={values.color_a_mostrar}
                    onChange={(color) =>
                      setFieldValue("color_a_mostrar", color)
                    }
                  />
                  {errors.color && (
                    <div>
                      <small className="text-danger">
                        {errors.id_encargado}
                      </small>
                    </div>
                  )}
                </Form.Group>
              </Modal.Body>
              <Modal.Footer>
                <Button
                  className="rounded-pill"
                  variant="secondary"
                  onClick={() => setShowModal(false)}
                >
                  Cerrar
                </Button>
                <Button
                  className="rounded-pill"
                  disabled={saveLoaderStatus}
                  variant="primary"
                  type="submit"
                >
                  {saveLoaderStatus && (
                    <Spinner
                      className="mr-2"
                      as="span"
                      animation="border"
                      size="sm"
                      role="status"
                      aria-hidden="true"
                    />
                  )}
                  Guardar
                </Button>
              </Modal.Footer>
            </Form>
          )}
        </Formik>
      </Modal>
    </>
  );
};

export default Sansiones_status;
